import { StyleSheet } from 'react-native';
import { COLORS, FONTS } from '../../../../constants';
import { STYLE_VARS } from '../../../../constants/style-vars';

export const myAccountStatementStyles = StyleSheet.create({
  table: {
    marginTop: 20,
    marginBottom: 50,
  },
  table_text: {
    fontSize: 12,
    letterSpacing: 1,
    fontFamily: FONTS.IowanOldStyleBTRoman,
    color: STYLE_VARS.fccDarkerGrey,
    textTransform: 'uppercase',
    fontWeight: '500',
  },
  thead: {
    flexDirection: 'row',
    // paddingHorizontal:20,
    paddingVertical: 15,
    backgroundColor: STYLE_VARS.kccBgGreen,
  },
  th_text: {
    fontSize: 12,
    fontFamily: FONTS.IowanOldStyleBTRoman,
    color: '#fff',
    textTransform: 'uppercase',
    fontWeight: '500',
  },
  tbody: {
    flexDirection: 'row',
    display: 'flex',
    flexWrap: 'wrap',
    // paddingHorizontal: 10,
    borderWidth: 1,
    borderTopWidth: 0,
    borderColor: COLORS.LIGHT_GREEN,
  },
  tbody_content: {
    paddingHorizontal: 5,
    paddingVertical: 15,
    borderWidth: 0.5,
    borderColor: STYLE_VARS.fccDarkGrey,
  },
  tfoot: {},
});
